// src/components/DownloadApp.js
import React from 'react';
import { motion } from 'framer-motion';

const DownloadApp = () => {
  const isIOS = () => {
    return [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod'
    ].includes(navigator.platform)
    || (navigator.userAgent.includes("Mac") && "ontouchend" in document);
  };

  const isAndroid = () => {
    return navigator.userAgent.match(/Android/i);
  };

  const getAppLink = () => {
    if (isIOS()) {
      return "https://apps.apple.com/tu-app"; // ← Reemplaza con tu link de App Store
    } else if (isAndroid()) {
      return "https://play.google.com/store/apps/details?id=tu.app.id"; // ← Reemplaza
    }
    return "#"; // Si no se detecta, muestra ambos botones (abajo)
  };

  const handleDownload = () => {
    const link = getAppLink();
    if (link !== "#") {
      window.open(link, '_blank');
    }
  };

  return (
    <section id="download" style={styles.section}>
      <div style={styles.container}>
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          style={styles.title}
        >
          Descarga la App de Quadramelo
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2, duration: 0.6 }}
          style={styles.subtitle}
        >
          Disponible para Android y iOS. ¡Empieza a ahorrar hoy!
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.4, duration: 0.6 }}
          style={styles.buttons}
        >
          {getAppLink() === "#" ? (
            <>
              <a
                href="https://play.google.com/store/apps/details?id=tu.app.id"
                target="_blank"
                rel="noopener noreferrer"
                style={{ ...styles.storeButton, marginRight: '1rem' }}
              >
                <img
                  src="/google-play-badge.png"
                  alt="Disponible en Google Play"
                  style={styles.storeBadge}
                />
              </a>
              <a
                href="https://apps.apple.com/tu-app"
                target="_blank"
                rel="noopener noreferrer"
                style={styles.storeButton}
              >
                <img
                  src="/app-store-badge.svg"
                  alt="Disponible en App Store"
                  style={styles.storeBadge}
                />
              </a>
            </>
          ) : (
            <button onClick={handleDownload} style={styles.downloadButton}>
              Descargar Ahora
            </button>
          )}
        </motion.div>
      </div>
    </section>
  );
};

const styles = {
  section: {
    padding: '6rem 1rem',
    backgroundColor: '#ffffff',
    textAlign: 'center',
  },
  container: {
    maxWidth: '800px',
    margin: '0 auto',
  },
  title: {
    fontSize: '2.5rem',
    fontWeight: '800',
    color: '#212529',
    marginBottom: '1rem',
    fontFamily: "'Poppins', sans-serif",
  },
  subtitle: {
    fontSize: '1.2rem',
    color: '#6c757d',
    marginBottom: '2.5rem',
    lineHeight: 1.6,
  },
  buttons: {
    display: 'flex',
    justifyContent: 'center',
    gap: '1.5rem',
    flexWrap: 'wrap',
  },
  downloadButton: {
    backgroundColor: '#4361ee',
    color: 'white',
    border: 'none',
    padding: '1rem 2.5rem',
    borderRadius: '14px',
    fontSize: '1.2rem',
    fontWeight: '700',
    cursor: 'pointer',
    boxShadow: '0 8px 20px rgba(67, 97, 238, 0.3)',
    transition: 'transform 0.2s, box-shadow 0.2s',
  },
  storeButton: {
    display: 'inline-block',
    width: '180px',
    transition: 'transform 0.2s',
  },
  storeBadge: {
    width: '100%',
    height: 'auto',
    display: 'block',
  },
};

export default DownloadApp;